import React from "react"
import { Page } from "react-onsenui";
import styles from './index.module.css'
import inlineStyles from "./inlineStyles";
import { IconExclamationMark } from "@tabler/icons-react";
import { useShowValidationResult } from "./useShowValidationResult";
import { datetimeStringFromSecondsSinceEpoch } from "../../../utils/time_helpers";

const ScannedTicketResult = (props) => {

    const {scan, onClickNext} = props
    const {setShowValidationResult} = useShowValidationResult()

    const {prev_scans} = scan
    const firstScan = prev_scans && prev_scans.sort((a, b) => a.created_at - b.created_at)[0]

    return (
        <>
            {scan &&
                <Page contentStyle={inlineStyles.modalBody} class={styles.scanned}>

                    <div className={styles.card}>
                        <div className={styles.eventName}>
                            {scan.event_name}
                        </div>

                        {scan.product_variant_title &&
                            <div className={styles.variantTitle}>
                                {scan.product_variant_title}
                            </div>
                        }

                        <div className={styles.indicator}>
                            <IconExclamationMark size={70}/>
                        </div>

                        <div className={styles.ticket}>
                            Valid Ticket
                        </div>

                        <div className={styles.scannedBy}>
                            Already scanned
                            {firstScan?.device_name &&
                                <span> by <span className={styles.deviceName}>{firstScan.device_name}</span></span>
                            }
                        </div>

                        {firstScan &&
                            <div className={styles.time}>
                                {datetimeStringFromSecondsSinceEpoch(firstScan.created_at)} 
                            </div>
                        }

                        <div className={styles.code}>
                            {scan.qr_data}
                        </div>
                    </div>

                    <button
                        className={styles.nextButton}
                        onClick={() => {
                            setShowValidationResult(false)
                            onClickNext()
                        }}
                    >
                        Next
                    </button>

                </Page>
            }
        </>
    )
}

export default ScannedTicketResult
